import { getScannedCode, ScannedCode } from '@/utils/scannedCode';

const VALID_CODE_SHAPE = /^[A-Z]{0,6}\d{4,}$/i;

export interface BulkParseResult {
  validEntries: ScannedCode[];
  unrecognizedLines: string[];
  stats: {
    totalLines: number;
    validCount: number;
    duplicateCount: number;
    unrecognizedCount: number;
  };
}

export const parseBulkCodes = (rawText: string): BulkParseResult => {
  const lines = rawText
    .split(/\r\n|\r|\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  const seen = new Set<string>();
  const validEntries: ScannedCode[] = [];
  const unrecognizedLines: string[] = [];
  let duplicateCount = 0;

  for (const line of lines) {
    const scanned = getScannedCode(line);

    if (!scanned || !VALID_CODE_SHAPE.test(scanned.code)) {
      unrecognizedLines.push(line);
      continue;
    }

    if (seen.has(scanned.code)) {
      duplicateCount += 1;
      continue;
    }

    seen.add(scanned.code);
    validEntries.push(scanned);
  }

  return {
    validEntries,
    unrecognizedLines,
    stats: {
      totalLines: lines.length,
      validCount: validEntries.length,
      duplicateCount,
      unrecognizedCount: unrecognizedLines.length,
    },
  };
};
